"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const jlDataUtils_1 = require("../../utils/jlDataUtils");
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const KevelAnalytics = ({ adId, type, clickUrl, impressionUrl, }) => {
    (0, react_1.useEffect)(() => {
        var _a;
        let eventListener = null;
        if (adId && type && clickUrl && impressionUrl) {
            // Detect if content is from browser cache
            const renderTimestamp = (_a = document
                .querySelector('meta[name="esi-render-time"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("content");
            const isCached = renderTimestamp
                ? Date.now() - parseInt(renderTimestamp) > 5000 // If older than 5 seconds, likely cached
                : false;
            if (isCached) {
                console.log("KevelAnalytics: ESI cached skipping impression logging");
                return;
            }
            const eventData = { adId, type, clickUrl, impressionUrl };
            (0, jlDataUtils_1.addKevelBannerToJlData)(eventData);
            const impressionEventData = Object.assign({ action: "kevel.impression" }, eventData);
            if (window && window.Bootstrapper && window.Bootstrapper.ensEventsReady) {
                (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)(impressionEventData);
            }
            else {
                eventListener = () => (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)(impressionEventData);
                document.body.addEventListener("ensEventsReady", eventListener, {
                    once: true,
                });
            }
        }
        else {
            (0, jlDataUtils_1.clearKevelBannersFromJlData)();
        }
        return () => {
            (0, jlDataUtils_1.clearKevelBannersFromJlData)();
            if (eventListener) {
                document.body.removeEventListener("ensEventsReady", eventListener);
            }
        };
    }, [adId, type, clickUrl, impressionUrl]);
    return null;
};
exports.default = KevelAnalytics;
